import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator"

// styles
import styles from "./CardsSlider.module.css"
import HomeFilesSlider from './HomeFilesSlider';

const CardsSlider = (props) => {

    const [filterHomeBtns, setFilterHomeBtns] = useState({
        filterBuy: true,
        filterRent: false,
    });

    let [dealType, setDealType] = useState(0);

    useEffect(() => {
        setDealType(props.dealType);
    }, []);

    useEffect(() => {
        if (props.dealType == 1){
            setFilterHomeBtns({
                filterBuy: false,
                filterRent: true
            });
        }else{
            setFilterHomeBtns({
                filterBuy: true,
                filterRent: false
            });
        }
    }, [props]);

    return (
        <>
            <section className="py-3">
                <div className="container-fluid">
                    <div
                        className="container d-flex flex-column justify-content-center flex-wrap align-items-center mt-3 px-0" dir='rtl'>
                        <div className="w-100 d-flex align-items-center justify-content-center">
                            <h2 className={styles.title}>
                                آخرین آگهی ها
                            </h2>
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center ps-0 mt-md-0 mt-3">
                            <Link to={props.dealType == 0 ? "/فایل-ها/خرید" : props.dealType == 1? "/فایل-ها/رهن-و-اجاره" : props.dealType == 2? "/فایل-ها/پیش-فروش" : "/فایل-ها/مشارکت"} className={`ms-md-5 ms-0 ${styles.gonext_container}`} >
                                مشاهده همه
                                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.19416 0.712087C8.56028 1.0782 8.56028 1.6718 8.19416 2.03791L4.16958 6.0625H14.0938C14.6115 6.0625 15.0312 6.48223 15.0312 7C15.0312 7.51777 14.6115 7.9375 14.0938 7.9375H4.16958L8.19416 11.9621C8.56028 12.3282 8.56028 12.9218 8.19416 13.2879C7.82805 13.654 7.23445 13.654 6.86834 13.2879L1.24334 7.66291C0.877221 7.2968 0.877221 6.7032 1.24334 6.33709L6.86834 0.712087C7.23445 0.345971 7.82805 0.345971 8.19416 0.712087Z" fill="#21409A" />
                                </svg>
                            </Link>
                        </div>

                        <div
                            className="container d-flex justify-content-center flex-wrap align-items-center my-3 px-0"
                            dir="ltr"
                        >
                            <HomeFilesSlider filterHomeBtns={filterHomeBtns} cardData={props.cardData} rentsCard={props.cardData} usePriceSeprator={usePriceSeprator} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );

    function filterBtnHandler(event) {
        if (event.target.id === "filterBuy") {
            setFilterHomeBtns((prev) => {
                return { ...prev, filterBuy: true, filterRent: false };
            });
        }
        else if (event.target.id === "filterRent") {
            setFilterHomeBtns((prev) => {
                return { ...prev, filterRent: true, filterBuy: false };
            });
        }
    }
};

export default CardsSlider;